import { createReducer } from '@reduxjs/toolkit';
import { receiveFeatureFlags } from './actions';

const featureFlagsReducer = createReducer({}, (builder) => {
  builder
  .addCase(receiveFeatureFlags, (state, action) => {
    const { keys, values } = action.payload;
    const flags = keys.reduce(
      (featureFlags, key: string, index: number) => {
        const keyCamel = key.replace(/[-.](.)/g, (_, group1) => {
          return group1.toUpperCase();
        });
        return {
          ...featureFlags,
          [keyCamel]: values[index].value
        };
      },
      {}
    );
    return {...state, ...flags};
  });
});

export default featureFlagsReducer;